import React from "react";
import { QqControlPropsType } from "./qq-control-props.type";
import { OptionValueModel } from "../model/option-value.model";
import { DropdownControlSettingsModel } from "../model/dropdown-control.settings.model";
import { dropdownAction } from "../message-interop/control-actions/dropdown.action";

export const QqDropdownControlRaw: React.FunctionComponent<
  QqControlPropsType<DropdownControlSettingsModel, OptionValueModel>
> = ({ qq, settings, dispatch }) => {
  if (qq.visible !== undefined && !qq.visible) return <span />;

  return (
    <div>
      <label htmlFor={`${qq.key}`}>{`${qq.text}`}</label>
      <select
        name={`${qq.key}`}
        id={`${qq.key}`}
        onChange={(e) => dispatch(dropdownAction(qq, e.target.value))}
      >
        {settings.values.map((v, index) => (
          <option key={index} value={v}>
            {v}
          </option>
        ))}
      </select>
    </div>
  );
};
